<template>
    <div class="m-viewport" id="mainView">

        <div class="logo-view">
          <h2 class="logo_1"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h2>
        </div>

        <div class="user-pannel">
            <user-info class="m-user"/>

            <div class="uis flex-center-center">
                <div class="u-btn rule" @click="$rule_modal()"></div>
                <div class="u-btn history" @click="call_record()"></div>
                <!-- <div class="u-btn friend-bind" @click="call_friend_bind()"></div> -->
            </div>
        </div>


        <loading v-show="Loading"/>

        <div class="view__body">
            <div class="page-wrapper">
                <transition name="fade" mode="out-in" appear>
                    <router-view v-if="isRouterAlive"></router-view>
                </transition>
            </div>          
        </div>

        <div class="web-nav" :class="{'ios' : $global.isIos , 'kd' : KD.isApp() ,'ios-26' : $global.getIOSVersion() >= 18.7 , 'ios-d' : $global.isDynamicIsland() }">
          <router-link 
          v-for="(item,index) in router_mainfest" 
          :key = index
          v-bind:to="item.link" 
          class="u-nav"
          :class="[item.name , 'n-' + (index + 1)]" 
          active-class="active">
          {{item.title}}
          </router-link>         
        </div>

    </div>
</template>

<script>
import {mapState} from 'vuex'
import loading from '@/components/loading.vue'
import {
    apiUserRecord,   
} from '@/api/index';
import KD from '@/assets/js/kd.js';

export default {
    components: {
        loading,
    },     
    data() {
        return {
            isRouterAlive : true,
            router_mainfest : [
                {name : 'index',title : '竞技争霸',link : '/index'},
                {name : 'shop',title : '回馈福利',link : '/shop'}, 
                {name : 'score',title : '邀请有礼',link : '/score'},
            ],
            KD,
            ua : navigator.userAgent.toLowerCase(),
        }
    },
    provide () {
        return {
            reload: this.reload
        }
    },          
    computed : {
        ...mapState(['Loading'])
    },  
    props : {
        ready : {
            default : false,
        },
    },
    provide () {
        return {
            reload: this.reload
        }
    },    
    mounted(){

    },
    methods: {
        async reload () {
            this.isRouterAlive = false
            await this.$nextTick(function () {
                this.isRouterAlive = true
            })
        },
        clearScreen(){
            const vcTooltipDom = document.getElementById('vc-tooltip')
            vcTooltipDom && document.body.removeChild(vcTooltipDom)              
        },
        call_record (){
            if(!this.$store.state.login){
                return this.$mslogin.login();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            apiUserRecord().then(
                res => {
                    this.$record_modal({ list : res.data });
                },
                rej => {},
            )
        },
        call_friend_bind(){
            if(!this.$store.state.login){
                return this.$mslogin.login();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.$friend_modal();
        },
    }        
}
</script>

<style lang="scss">

.m-viewport{
    position: relative;
    width: 750px;
    max-height: 6872px;
    padding-top: 1280px;
    margin: 0 auto 0;
    background-repeat: no-repeat;
    background-position: center top;
    box-sizing: border-box;
    font-size: 24px;
    background-image: url(~@/assets/images/cover.jpg);
    background-color: #f4ddbc;
    color: #caa97d;
    overflow-x: hidden;
    overflow-y: hidden;
    box-shadow: rgba(0, 0 , 0 , 0.5) 1px 2px 10px;
    /* overflow-y: scroll;    */ 

}

.logo-view{
    display: flex;
    align-items: center;
    position: absolute;
    left: 2%;
    top: 42px;
    z-index: 3;
}

.logo-view a{
    display: block;
    width: 100%;
    height: 100%;
}

.logo-view .logo_1{
    width: 124px;
    height: 98px;
    background-image: url(~@/assets/images/logo.png);
}

.user-pannel{
    position: absolute;
    left: 50%;
    top: 1100px;
    transform: translateX(-50%);
    width: 100%;
    z-index: 3;
    text-align: center;
}

.m-user{
    height: 48px;
    line-height: 48px;
    color: #7a6e5a;
    background-image: url(~@/assets/images/bg-user.png);
    background-position: center;
    background-repeat: no-repeat;
}

.uis{
    margin-top: 24px;
    .u-btn{
        width: 207px;
        height: 66px;
        margin: 0 18px 0;

        &.rule{
            background-image: url(~@/assets/images/btn-rule.png);
        }

        &.history{
            background-image: url(~@/assets/images/btn-history.png);
        }
        
        &.friend-bind{
            background-image: url(~@/assets/images/btn-friend.png);
        }        
    }
}

.view__body{
    //padding-top: 58px;
}

.page-body{
    position: relative;
    margin-top: 40px;

}

.page-wrapper{
    //padding-top: 58px;
}

/* nav */
.web-nav {
    display: flex;
    position: fixed;
    left: 50%;
    bottom: 0;
    z-index: 10;
    transform: translateX(-50%);    
    width: 750px;
    justify-content: space-around;
    align-items: flex-end;
    box-sizing: border-box;
    background-color: #9b1b13;
}

.web-nav.ios.kd{
    bottom: 0px;
}

.web-nav.ios-d.kd{
    bottom: 50px;
}

.pc .web-nav{
    // margin-left: -7px;
}

.web-nav .u-nav {
    width: 248px;
    height: 96px;
    color: transparent;
    font-size: 0;
    background-repeat: no-repeat;
    background-position: center;

    @for $i from 1 through 3 {
        &.n-#{$i} {
            background-image: url(~@/assets/images/nav/#{$i}.png);

            &.active{
                background-image: url(~@/assets/images/nav/#{$i}a.png);
            }
        }
    } 

}

/* 按常见 iPhone 机型尺寸/像素比做覆盖（仅作兜底，不保证所有 WebView 都准确） */
/* iPhone 14 Pro / 13 Pro / 12 Pro (CSS 尺寸 393x852, DPR 3) */
@media only screen and (orientation: portrait) and (device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3) {
  .web-nav.ios-d.kd { bottom: 50px; }
}

/* iPhone 14 Pro Max / 13 Pro Max / 12 Pro Max (428x926, DPR 3) */
@media only screen and (orientation: portrait) and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) {
  .web-nav.ios-d.kd { bottom: 50px; }
}

/* iPhone 12/13/14 / 12/13/14 mini 常见非 Pro 小刘海 (390x844, DPR 3) */
@media only screen and (orientation: portrait) and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
  .web-nav.ios-d.kd { bottom: 40px; }
}

/* iPhone X / XS / 11 Pro (375x812, DPR 3) */
@media only screen and (orientation: portrait) and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .web-nav.ios-d.kd { bottom: 40px; }
}

/* iPhone XR / 11 (414x896, DPR 2) */
@media only screen and (orientation: portrait) and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .web-nav.ios-d.kd { bottom: 40px; }
}
</style>
